import { Action } from 'redux';
import { IAppState } from '../../../state/reducers';

export enum ActionType {
  UpdateCurrentEditingClipIndex = 'currentEditingClip.UpdateCurrentEditingClipIndex',
  ResetCurrentEditingClipIndex = 'CurrentPlayingClip.resetCurrentEditingClipIndex',
  UpdateLastEditedClipIndex = 'currentEditingClip.UpdateLastEditedClipIndex',
  ResetLastEditedClipIndex = 'CurrentPlayingClip.ResetLastEditedClipIndex',
}

export interface ICurrentEditingClipAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  currentIndex: number,
  lastEditedIndex: number,
}

const INITIAL_STATE: IState = {
  currentIndex: -1,
  lastEditedIndex: -1,
};

export default function reducer(state = INITIAL_STATE, action: ICurrentEditingClipAction) {
  switch (action.type) {
    case ActionType.UpdateCurrentEditingClipIndex:
      return {
        ...state,
        currentIndex: action.payload,
      };
    case ActionType.ResetCurrentEditingClipIndex:
      return {
        ...state,
        currentIndex: INITIAL_STATE.currentIndex,
      };
    case ActionType.UpdateLastEditedClipIndex:
      return {
        ...state,
        lastEditedIndex: action.payload,
      };
    case ActionType.ResetLastEditedClipIndex:
      return {
        ...state,
        lastEditedIndex: INITIAL_STATE.lastEditedIndex,
      };
    default:
      return state;
  }
}

export const updateCurrentEditingClipIndex = (index: number) => ({
  type: ActionType.UpdateCurrentEditingClipIndex,
  payload: index,
});

export const resetCurrentEditingClipIndex = () => ({
  type: ActionType.ResetCurrentEditingClipIndex,
});

export const selectIsClipEditing = (state: IAppState, clipIndex: number) => (
  state.currentEditingClip.currentIndex === clipIndex
);

export const updateLastEditedClipIndex = (index: number) => ({
  type: ActionType.UpdateLastEditedClipIndex,
  payload: index,
});

export const resetLastEditedClipIndex = () => ({
  type: ActionType.ResetLastEditedClipIndex,
});
